
























































































































































































import {
  defineComponent,
  SetupContext,
  ref,
  computed,
  PropType,
  onMounted,
  onUnmounted,
  useRouter,
} from '@nuxtjs/composition-api';
import { NULL } from 'node-sass';
import { Swiper } from 'swiper';
import useAppRoute from '~/compositions/useAppRoute';
import { useAppStore } from '~/store/app';
interface SwiperTabItem {
  label: string;
  url: string;
  badge?: number;
  isHidden?: boolean;
}
interface HeaderOptions {
  fixed: boolean;
  marginTop: number;
  width?: number | string;
}
const defaultHeaderOptios: HeaderOptions = {
  fixed: true,
  marginTop: 0,
};
export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0,
    },
    headerOptions: {
      type: Object as PropType<HeaderOptions>,
      default: () => defaultHeaderOptios,
    },
    swiper_items: {
      type: Array as PropType<SwiperTabItem[]>, // PropType で型の情報を付与
      required: true,
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    includeSearchArea: {
      type: Boolean,
      default: false,
    },
    touchMove: {
      type: Boolean,
      default: true,
    },
    defaultTub: {
      type: Number,
      default: null,
    },
  },
  setup(props, context: SetupContext) {
    const { URLs } = useAppRoute();
    const { store } = useAppStore();
    const router = useRouter();

    const isSignIn = store.isSignedIn;
    // @ts-ignore TODO: 一旦こうしておくけど後でちゃんとやる
    const swiperTabComponent = ref<HTMLDivElement>(null);
    // propsで渡されるheaderOptions?.fixedがtrueであり、margintopが設定されていない場合
    const isFixedTop =
      props.headerOptions?.fixed && !props.headerOptions?.marginTop;

    const isFixed = ref(isFixedTop); // true,false

    onMounted(() => {
      // // 移動した時に一番上に来るように
      swiperTabComponent.value
        ?.querySelectorAll('.swiper-slide')
        ?.forEach((elem) => {
          elem.addEventListener('scroll', (event: any) => {
            if (!isFixed.value) {
              // @ts-ignore
              context.root.$scrollTo(window, 0, {
                offset: event.target.scrollTop,
              });
              // window.scrollTo({ top: event.target.scrollTop });
              // event.target.scrollTop = 0;
            }
          });
        });
    });
    onUnmounted(() => {
      swiperTabComponent.value
        ?.querySelectorAll('.swiper-slide')
        ?.forEach((elem) => {
          elem.removeEventListener('scroll', () => {});
        });
    });
    const swiperComponentRef = ref<any>(null);
    const swiperComponentinstance = computed(
      () => swiperComponentRef.value?.$swiper as Swiper
    );
    // 渡されてきたアイテムの情報を元に、正規表現のマッチャーを作る
    const path_matcher = props.swiper_items.map(
      (item) => new RegExp(`(/.+/)*${item.url}$`)
    );
    // 現在選択中のタブのIndexを返却
    const getTabIndex = () => {
      // 現在のURLを各タブコンテンツのURLと照らし合わせ、マッチするタブIDを取得する
      const index = path_matcher.findIndex((matcher) =>
        matcher.test(router.currentRoute.path)
      );
      // 一致するタグがなかったので何かおかしい
      if (index < 0) {
        throw new Error('タブとコンテンツの数を一致させてください');
      }
      // 一致した位置のインデックスを返却する
      return index;
    };

    const activeIndex = ref(getTabIndex());
    // Swiperオプション
    const swiperOptions = {
      effect: 'fade',
      allowTouchMove: props.touchMove,
      initialSlide: getTabIndex(),
      // スワイプしてる最中に別のスライドに移動することができなくなる。遷移アニメーションによっては便利。デフォルトではfalse。
      preventIntercationOnTransition: true,
      on: {
        // スライド移動してアニメーション終了した時の処理
        slideChangeTransitionEnd: (swiper: Swiper) => {
          const path = props.swiper_items[swiper.activeIndex].url;
          router.push(path);
          activeIndex.value = swiper.activeIndex;
          context.emit('input', swiper.activeIndex);
        },
      },
    };
    // タブ変更
    const changeTab = (index: number) => {
      swiperComponentinstance.value?.slideTo(index);
    };

    const tabCount = props.swiper_items.length;
    const tabLayout = tabCount === 2 ? '-tabs2-layout' : '-tabs3more-layout';

    const tabsContaierWidth = computed(() => {
      const width = props.headerOptions.width || '100%';
      return typeof width === 'string' ? width : `${width}rem`;
    });

    const tubClickEvent = (index: number) => {
      changeTab(index);
      context.emit('change-tub', index);
    };

    onMounted(() => {
      if (props.defaultTub) {
        changeTab(props.defaultTub);
      }
    });

    return {
      URLs,
      isSignIn,
      swiperComponentRef,
      swiperOptions,
      activeIndex,
      changeTab,
      swiperTabComponent,
      tabCount,
      tabLayout,
      tabsContaierWidth,
      tubClickEvent,
    };
  },
});
